const roles = {
  moduleTitle: "Permissions",
  actions: {
    create: "Create role",
    view: "View",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
  },
  permissions: {
    core: "Core",
    permissionManagement: "Permission management",
    roles: "Roles",
  },
  list: { title: "Permissions", subtitle: "Create and manage permissions" },
  toolbar: {
    // The list screen's own toolbar button -- separate from actions.create,
    // which also labels the CRUD "create" permission in the matrix.
    add: "Add permission",
    filters: "Filters",
  },
  filters: {
    search: "Search roles",
    searchPlaceholder: "Search by name",
    status: "Status",
    statusAll: "All statuses",
  },
  status: {
    active: "Active",
    inactive: "Inactive",
  },
  table: {
    name: "Name",
    nameEn: "English name",
    nameAr: "Arabic name",
    permissionsCount: "Permissions",
    permissionsCountValue: "{{count}} permissions",
    status: "Status",
    createdAt: "Created at",
    actions: "Actions",
    actionMenu: "Role actions",
    empty: "No roles match these filters.",
    error: "Roles could not be loaded.",
    loading: "Loading roles",
    showing: "Showing {{count}} of {{total}}",
    rowsPerPageLabel: "Rows per page",
    nextPage: "Next page",
    previousPage: "Previous page",
    pagination: "Pagination",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
  },
  deleteDialog: {
    title: "Delete",
    question: "Are you sure you want to delete this role?",
    warning: "This action is permanent and cannot be undone.",
    confirmWord: "Delete",
    instruction: 'Type "{{word}}" to confirm deletion',
    inputLabel: "Deletion confirmation",
    cancel: "Cancel",
    confirm: "Delete",
    close: "Close delete dialog",
    success: "Role deleted successfully.",
  },
  form: {
    createTitle: "Create role",
    // Used only for the breadcrumb crumb on create -- the page heading
    // itself stays createTitle.
    createBreadcrumb: "Create permission",
    editTitle: "Edit role",
    createSubtitle: "Enter the role's name and select its permissions.",
    editSubtitle: "Update the role's name, status, and permissions.",
    back: "Back to permissions",
    details: "Role details",
    nameEn: "English name",
    nameAr: "Arabic name",
    isActive: "Active",
    statusDialog: {
      titleActivate: "Activate Role",
      titleDeactivate: "Deactivate Role",
      questionActivate: "Are you sure you want to activate this role?",
      questionDeactivate: "Are you sure you want to deactivate this role?",
      note: "This change won't be applied until you save.",
      yes: "Yes",
      no: "No",
      close: "Close status change dialog",
    },
    loading: "Loading role",
    loadError: "Role could not be loaded.",
  },
  matrix: {
    title: "Permissions",
    description: "Select permissions available to this account.",
    expand: "Expand",
    collapse: "Collapse",
  },
  detail: {
    title: "Role details",
    subtitle: "Details and basic information for the profile",
    loading: "Loading role",
    error: "Role could not be loaded.",
    notAvailable: "Not available",
  },
};

export default roles;
